// eslint-disable-next-line import/prefer-default-export
export const CONTENT_SUBMISSION_ROUTES = {
  contentSubmissionsList: '',
  parentContentSubmission: 'mixed-media/:parentContentSubmissionId',
  contentSubmission: ':contentSubmissionId',
  mixedMediaContentSubmission:
    'mixed-media/:parentContentSubmissionId/:contentSubmissionId',
} as const;
